import classNames from 'classnames';
import Icon, { INameExtended } from 'components/Icon';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import { breakTranslationNewlines } from '../../../utils';
import * as Styled from './Card.styled';

type CardProps = {
  iconName?: INameExtended;
  title: string;
  description?: string | string[];
  step?: number;
  last?: boolean;
  type?: 'howItWorks' | 'criteria';
  showChecks?: boolean;
  className?: string;
};

const Card = (props: CardProps) => {
  const {
    iconName,
    title,
    description,
    step,
    last,
    className,
    type = 'howItWorks',
    showChecks = true,
  } = props;

  const { t } = useTranslation();

  return (
    <Styled.Card
      className={classNames(
        'cedolauto-card',
        {
          'cedolauto-card--last': last,
          'cedolauto-card--criteria': type === 'criteria',
        },
        className
      )}
    >
      {iconName && <Icon name={iconName} className="cedolauto-card__icon" />}

      {type === 'howItWorks' && (
        <div className="cedolauto-card__step">{step}</div>
      )}

      <p className="cedolauto-card__title">
        {parse(breakTranslationNewlines(t(title)))}
      </p>
      {description && (
        <div className="cedolauto-card__description">
          {typeof description === 'string' ? (
            parse(breakTranslationNewlines(t(description)))
          ) : (
            <ul className="cedolauto-card__descriptions">
              {description?.map((desc, index) => (
                <li key={index} className="cedolauto-card__descriptions__item">
                  {showChecks && <Icon name="circle-check-solid" />}{' '}
                  <p>{parse(breakTranslationNewlines(t(desc)))}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </Styled.Card>
  );
};

export default Card;
